export type SpaceSpacing = "xs" | "sm" | "md" | "lg";
export type SpaceDirection = "row" | "column";
export type SpaceAlign = "start" | "end" | "center" | "stretch";
export const SpaceSpacingSize: Record<string, number> = {
  xs: 10,
  sm: 12,
  md: 16,
  lg: 20,
};
